import React, { FC } from 'react'
import { FormProvider, FormProviderProps } from 'react-hook-form'
import { Button } from 'transfix-ui/components/Button'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export interface IEditingFormProps {
  isEditing: boolean
  loading?: boolean
  onCancel: () => void
  onSubmit: () => void
  formMethods: Omit<FormProviderProps, 'children'>
}

const useEditingForm = makeStyles(theme => ({
  saveButton: { marginLeft: theme.spacing(2) },
}))

export const EditingForm: FC<IEditingFormProps> = ({
  children,
  formMethods,
  isEditing,
  loading,
  onCancel,
  onSubmit,
}) => {
  const styles = useEditingForm()

  if (!isEditing) {
    return <div>{children}</div>
  }

  return (
    <FormProvider {...formMethods}>
      <Box bgcolor={brandColors.coolGray1} p={3}>
        <form onSubmit={onSubmit}>
          {children}
          <Box display='flex' justifyContent='flex-end' mt={5}>
            <Button color='tertiary' onClick={onCancel}>
              Cancel
            </Button>
            <Button disabled={loading} color='primary' className={styles.saveButton} type='submit'>
              Save Changes
            </Button>
          </Box>
        </form>
      </Box>
    </FormProvider>
  )
}
